import { tv } from 'tailwind-variants'

export const replyMessageVariants = tv({
  slots: {
    container: 'flex font-normal text-base',
    icon: 'flex items-center cursor-pointer text-secondary-medium text-micro',
  },
  variants: {
    size: {
      small: {
        icon: 'text-micro'
      },
      medium: {
        icon: 'text-deca'
      },
      large: {
        icon: 'text-kilo'
      }
    }
  }
})
